import { ChangeEvent, FormEvent, useState } from 'react';
import { login, uri } from '../api';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const SERVER_PORT = 3000;

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from =
    (location.state as { from?: Location } | null)?.from?.pathname ??
    '/my-games';

  const handleChangeUsername = (event: ChangeEvent<HTMLInputElement>) =>
    setUsername(event.target.value);
  const handleChangePassword = (event: ChangeEvent<HTMLInputElement>) =>
    setPassword(event.target.value);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const ok = await login(username, password);
      if (ok) {
        navigate(from, { replace: true });
      } else {
        setError('Invalid username or password.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter">
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">Username or Email</label>
            <input
              className="input"
              type="text"
              value={username}
              onChange={handleChangeUsername}
              autoFocus
            />
          </div>
          <div className="field">
            <label className="label">Password</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={handleChangePassword}
            />
          </div>
          <button
            className={`button is-primary${loading ? ' is-loading' : ''}`}
            type="submit"
          >
            Login
          </button>
          {error && <p className="has-text-danger mt-3">{error}</p>}
        </form>

        <hr />

        {/* <div className="buttons">
          <a
            className="button is-light"
            href={`${uri}:${SERVER_PORT}/auth/google`}
          >
            Continue with Google
          </a>
          <a
            className="button is-light"
            href={`${uri}:${SERVER_PORT}/auth/github`}
          >
            Continue with GitHub
          </a>
          <a
            className="button is-light"
            href={`${uri}:${SERVER_PORT}/auth/discord`}
          >
            Continue with Discord
          </a>
        </div> */}

        <p className="mt-2">
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className="mt-2">
          No account yet? <Link to="/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}
